import { render, staticRenderFns } from "./UpdateHubDetails.vue?vue&type=template&id=e336118a"
import script from "./UpdateHubDetails.vue?vue&type=script&lang=js"
export * from "./UpdateHubDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports